<template>
  <span class="beta-chip" :style="applyColorStyles()">
    BETA
  </span>
</template>
<script>
export default {
  name: 'beta-chip',
  props: {
    color: {
      type: String,
      default: ''
    }
  },
  methods: {
    applyColorStyles: function () {
      if (this.color) {
        return {
          'color': this.color,
          'border-color': this.color,
        }
      }
      return {}
    }
  }
}
</script>
<style scoped lang="scss">
 @import '~styles/_variables.scss';

.beta-chip {
  margin-left: 4px;
  background-color: inherit;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  padding: 2px 7px;
  border-radius: 5px;
  border-color: #fff;
  border: 1px solid;
}
</style>
